import { render, staticRenderFns } from "./parkingBoxManageList.vue?vue&type=template&id=5f0cf0b0&scoped=true"
import script from "./parkingBoxManageList.vue?vue&type=script&lang=js"
export * from "./parkingBoxManageList.vue?vue&type=script&lang=js"
import style0 from "./parkingBoxManageList.vue?vue&type=style&index=0&id=5f0cf0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0cf0b0",
  null
  
)

export default component.exports